module.exports = __webpack_public_path__ + "img/1B1B1B_515151_7E7E7E_6C6C6C-256px.7d818410.png";